import Peer from 'skyway-js';
import { CHELSkywayPlayer } from './CHELSkyPlayer';
import { HEL_AUDIO_TYPE_VOICE, SKYWAY_API_HOST, worldViewerWindow } from './const';
import { debugLog } from './debugLog';
import { helcore_video_play } from './heliodor_core_video_callee';
import { closeLocalStream, closeSkywayRoom, destroyPeer, getLocalStream, getMixerRealSettingAt, getPeer, getSkyRoomId, getSkywayKey, getSkywayName, getSkywayOnTellScreenShareStart, getSkywayOnTellWaitScreenShare, getSkywayPlayerList, getWorldId, setLocalStream, setPeer, setSkyRoomId, setSkywayAvatarNumber, setSkywayAvatarNumberForSend, setUseSkywayAudioGainToggle, setSkywayName, setSkywayPlayerList, setSkywayRoom } from './logics/dataOps';
import { getVideo, setVideo } from './logics/domOps';
import { requestSendingReceivedPacketsFromSkyway } from './logics/moduleCaller';
// 画面共有
const g_ScreenShare_Use = false;
let g_ScreenShare_LocalStream;
let g_useVideoStreamFlag = false;
// ビデオストリーム保持用Map
const videoStreams = new Map();
worldViewerWindow.hel_set_video_stream_use = (flag)=>{
    g_useVideoStreamFlag = flag;
    return g_useVideoStreamFlag;
};
worldViewerWindow.hel_get_video_stream_use = ()=>{
    return g_useVideoStreamFlag;
};
/**
 * heliodor_skyway_rcpから参照があるためglobal関数
 * @param peerId
 */ worldViewerWindow.hel_skyway_create_player = (peerId)=>{
    const skywayPlayer = new CHELSkywayPlayer(peerId, getMixerRealSettingAt(HEL_AUDIO_TYPE_VOICE));
    const skywayPlayerList = getSkywayPlayerList();
    // debugLog("hel_skyway_create_player " + peerId);
    for(let n = 0; n < skywayPlayerList.length; n++){
        if (skywayPlayerList[n] === null) {
            setSkywayPlayerList(skywayPlayer, n);
            return skywayPlayer;
        }
    }
    skywayPlayerList.push(skywayPlayer);
    return skywayPlayer;
};
/**
 * heliodor_skyway_xrw, heliodor_skyway_rcpから参照があるためglobal関数
 * @param peerId
 */ worldViewerWindow.hel_skyway_release_player = (peerId)=>{
    const skywayPlayerList = getSkywayPlayerList();
    for(let n = 0; n < skywayPlayerList.length; n++){
        const skywayPlayer = skywayPlayerList[n];
        if (skywayPlayer === null) {
            continue;
        }
        if (skywayPlayer.getPeerId() === peerId) {
            skywayPlayer.release();
            setSkywayPlayerList(null, n);
            return;
        }
    }
};
/**
 * heliodor_skyway_xrw, heliodor_skyway_rcpから参照があるためglobal関数
 */ const helcore_skyway_release_all_player = ()=>{
    const skywayPlayerList = getSkywayPlayerList();
    for(let n = 0; n < skywayPlayerList.length; n++){
        const skywayPlayer = skywayPlayerList[n];
        if (skywayPlayer === null) {
            continue;
        }
        worldViewerWindow.hel_skyway_receive_data('leave', skywayPlayer.getPeerId(), '');
        skywayPlayer.release();
        setSkywayPlayerList(null, n);
    }
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrw, heliodor_xrw_mainから参照があるためglobal関数
 * @param peerId
 */ worldViewerWindow.hel_skyway_get_player = (peerId)=>{
    const skywayPlayerList = getSkywayPlayerList();
    for(let n = 0; n < skywayPlayerList.length; n++){
        const skywayPlayer = skywayPlayerList[n];
        if (skywayPlayer === null) {
            continue;
        }
        if (skywayPlayer.getPeerId() === peerId) {
            return skywayPlayer;
        }
    }
    return null;
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param stream
 */ worldViewerWindow.hel_skyway_stream = (stream)=>{
    if (!stream.peerId) {
        debugLog('stream.peerId not');
        return;
    }
    let player = worldViewerWindow.hel_skyway_get_player(stream.peerId);
    if (player === null) {
        player = worldViewerWindow.hel_skyway_create_player(stream.peerId);
        if (player === null) {
            debugLog('hel_skyway_get_player not ' + stream.peerId);
            return;
        }
    }
    player.setStream(stream);
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param volume
 */ worldViewerWindow.hel_skyway_SetMixerVolume = (volume)=>{
    const skywayPlayerList = getSkywayPlayerList();
    for(let n = 0; n < skywayPlayerList.length; n++){
        const skywayPlayer = skywayPlayerList[n];
        if (skywayPlayer === null) {
            continue;
        }
        skywayPlayer.setVolume(volume);
    }
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param roomid
 */ worldViewerWindow.hel_skyway_set_roomid = (roomid)=>setSkyRoomId(roomid)
;
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 */ worldViewerWindow.hel_skyway_get_roomid = ()=>getSkyRoomId()
;
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 */ worldViewerWindow.hel_skyway_set_avatar_from_cookie = ()=>{
    const avatar = worldViewerWindow.hel_get_cookie('Avatar');
    if (avatar !== undefined && avatar !== -1) {
        setSkywayAvatarNumber(avatar);
        setSkywayAvatarNumberForSend(avatar);
    }
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param cmd
 * @param id
 * @param param
 */ worldViewerWindow.hel_skyway_receive_data = (cmd, id, param)=>{
    const data = cmd + ':' + id + ':' + param;
    // debugLog("receive_data / " + data);
    requestSendingReceivedPacketsFromSkyway(data);
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param id
 * @param text
 */ worldViewerWindow.hel_skyway_add_text_chat = (id, text)=>{
    worldViewerWindow.hel_skyway_receive_data('data', id, 'msg:' + text);
    // チャットログスクロール対応
    if (typeof worldViewerWindow.hel_if_displayChatMessage === 'function') {
        worldViewerWindow.hel_if_displayChatMessage(id, text);
    }
    worldViewerWindow.hel_chatbadge_ui_update(); // チャットログバッジのUI更新
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param id
 * @param text
 */ worldViewerWindow.hel_chatbadge_ui_update = ()=>{
    // チャットログのバッジ判定＋表示
    if (typeof worldViewerWindow.hel_if_displayChatBadge === 'function') {
        worldViewerWindow.hel_if_displayChatBadge();
    } else {
        //gudのチャットログアイコンのバッジの表示設定
        worldViewerWindow.hel_canvas_ResetToggleDefault("IsVisible_hud_textchatbadge"); //初期値はfalse（＝非表示）
        if (worldViewerWindow.hel_canvas_GetLayerShow("ChatLogView") || worldViewerWindow.hel_canvas_GetLayerShow("config_base") || worldViewerWindow.hel_canvas_GetLayerShow("photo_layer")) {
        //チャットログ表示中は何もしない
        //フォトモード表示中は何もしない
        } else {
            //チャットログ横のバッジを表示させる
            worldViewerWindow.hel_canvas_ToggleChange("IsVisible_hud_textchatbadge"); //trueに変更（＝表示）
            worldViewerWindow.hel_canvas_SetGUIShow("HUD", "hud_textchatbadge", true);
            worldViewerWindow.hel_canvas_SetGUIShow("HUD_po", "hud_textchatbadge", true);
        }
    }
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @remarks
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @param peerId
 * @param mute
 * @virtual
 */ worldViewerWindow.hel_skyway_SetVoiceMute = (peerId, mute)=>{
    const Player = worldViewerWindow.hel_skyway_get_player(peerId);
    if (Player === null) return;
    // eslint-disable-next-line new-cap
    Player.SetMute(mute);
};
//
const getSkywayRoomID = ()=>{
    const parts = location.hostname.split('.');
    const subdomain = parts.shift();
    const skywayRoomId = subdomain + '_' + getSkyRoomId();
    return skywayRoomId;
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrw, heliodor_xrw_mainから参照があるためglobal関数
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @virtual
 */ worldViewerWindow.hel_skyway_join = ()=>{
    helcore_skyway_join_by_roomid(getSkywayRoomID());
};
/**
 */ const helcore_skyway_join_by_roomid = (roomid)=>{
    // const leaveTrigger = document.getElementById('js-leave-trigger');
    const remoteVideos = document.getElementById('js-remote-streams');
    // Note that you need to ensure the peer has connected to signaling server
    // before using methods of peer instance.
    const peer = getPeer();
    const localStream = getLocalStream();
    if (peer === undefined || localStream === undefined) {
        debugLog('worldViewerWindow.g_peer or worldViewerWindow.g_localStream is undefined');
        return;
    }
    if (!peer.open) {
        debugLog('hel_skyway_join : worldViewerWindow.g_peer not open');
        return;
    }
    //
    const room = peer.joinRoom(roomid, {
        mode: 'mesh',
        stream: localStream,
        videoReceiveEnabled: true
    });
    setSkywayRoom(room);
    room.once('open', ()=>{
        // worldViewerWindow.hel_skyway_add_text_chat("", 'You joined');
        worldViewerWindow.hel_skyway_receive_data('open', peer.id, '');
        // to set my name
        worldViewerWindow.hel_skyway_receive_data('data', peer.id, 'name:' + getSkywayName());
        // send my name to old player
        worldViewerWindow.hel_skyway_send_myinfo();
    });
    room.on('peerJoin', (peerId)=>{
        worldViewerWindow.hel_skyway_create_player(peerId);
        // worldViewerWindow.hel_skyway_add_text_chat("", `${peerId} joined`);
        // worldViewerWindow.hel_skyway_receive_data("join", peerId, "");
        // send my name to new player
        worldViewerWindow.hel_skyway_send_myinfo();
        // 新たにジョインしたプレイヤーに対して、既に画面共有していた場合はstreamを送る
        helcore_skyway_screenshare_to_player(peerId);
    });
    // Render remote stream for new peer join in the room
    room.on('stream', async (stream)=>{
        worldViewerWindow.hel_skyway_stream(stream);
        // 映像ストリームを含んでいた場合、再生可能にするため格納する
        const remoteVideoStreamTracks = stream.getVideoTracks();
        if (remoteVideoStreamTracks.length > 0) {
            const remoteVideoStream = new MediaStream(remoteVideoStreamTracks);
            // @ts-ignore
            const peerId = stream.peerId || stream.id;
            videoStreams.set(peerId, remoteVideoStream);
        }
        const newAudio = document.createElement('audio');
        newAudio.srcObject = stream;
        newAudio.playsInline = true;
        // mark peerId to find it later at peerLeave event
        newAudio.setAttribute('data-peer-id', stream.peerId);
        remoteVideos.append(newAudio);
        await newAudio.play().catch(console.error);
    });
    // 画面共有用にstreamを受けるのに使用する
    peer.on('call', (mediaConnection)=>{
        console.log('Skyway called');
        // このanswerで答えることでこの下のstreamを受けることが出来る
        mediaConnection.answer(getLocalStream());
        mediaConnection.on('stream', async (stream)=>{
            console.log('Skyway call stream');
            // Render remote stream for callee
            const updatedVideo = document.getElementById('video0');
            setVideo(updatedVideo);
            const video = getVideo();
            if (video) {
                console.log('video connect');
                video.srcObject = stream;
                video.playsInline = true;
                await video.play().catch(console.error);
            } else {
                console.log('video null');
            }
        });
    });
    //
    room.on('data', ({ data , src  })=>{
        // Show a message sent to the room and who sent
        //      messages.textContent += `${src}: ${data}\n`;
        // debugLog(`${src}: ${data}`);
        if (data === 'screenshare:tell') {
            const fn = getSkywayOnTellScreenShareStart();
            if (fn !== undefined) {
                fn();
                return;
            }
        } else if (data === 'screenshare:waitstart') {
            const fn = getSkywayOnTellWaitScreenShare();
            if (fn !== undefined) {
                fn();
                return;
            }
        }
        if (data.startsWith('screenshare:')) {
            const paramsScreenShare = data.split(':');
            if (paramsScreenShare[1] === 'start') {
                // グローバルにhel_onReceiveNoticeScreenShareStartが定義されていた場合に実行する
                if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStart === 'function') {
                    const remoteStream = videoStreams.get(src);
                    if (worldViewerWindow.hel_video_is_playing_same_stream(remoteStream)) {
                        return;
                    }
                    worldViewerWindow.hel_onReceiveNoticeScreenShareStart(src, remoteStream, paramsScreenShare[2], paramsScreenShare[3]);
                }
            }
            if (paramsScreenShare[1] === 'stop') {
                // グローバルにhel_onReceiveNoticeScreenShareStopが定義されていた場合に実行する
                if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStop === 'function') {
                    worldViewerWindow.hel_onReceiveNoticeScreenShareStop(src);
                }
            }
        }
        worldViewerWindow.hel_skyway_receive_data('data', src, data);
        // dataが 'msg:' の場合は、チャットメッセージ。なのでチャットのバッジ更新を行う。
        if (data.startsWith('msg:')) {
            worldViewerWindow.hel_chatbadge_ui_update(); // チャットログバッジのUI更新
        }
    });
    // for closing room members
    room.on('peerLeave', (peerId)=>{
        worldViewerWindow.hel_skyway_release_player(peerId);
        const remoteVideo = remoteVideos.querySelector(`[data-peer-id="${peerId}"]`);
        remoteVideo.srcObject.getTracks().forEach((track)=>track.stop()
        );
        remoteVideo.srcObject = null;
        remoteVideo.remove();
        if (videoStreams.has(peerId)) {
            // ビデオストリームの除去
            videoStreams.delete(peerId);
            if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStop === 'function') {
                worldViewerWindow.hel_onReceiveNoticeScreenShareStop(peerId);
            }
        }
        // messages.textContent += `=== ${peerId} left ===\n`;
        // worldViewerWindow.hel_skyway_add_text_chat("", `${peerId} leaved`);
        worldViewerWindow.hel_skyway_receive_data('leave', peerId, '');
    });
    // for closing myself
    room.once('close', ()=>{
        Array.from(remoteVideos.children).forEach((remoteVideo)=>{
            remoteVideo.srcObject.getTracks().forEach((track)=>track.stop()
            );
            remoteVideo.srcObject = null;
            remoteVideo.remove();
        });
        helcore_skyway_release_all_player();
    });
};
/**
 * @remarks
 * 呼出元でmediaDevicesがundefinedでないことを確認
 */ const setLocalAudioStreamBy = async ()=>{
    const localStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
    }).catch(console.error);
    setLocalStream(localStream);
    return localStream;
};
const replaceLocalStream = (stream)=>{
    worldViewerWindow.g_room.replaceStream(stream);
    setLocalStream(stream);
};
const setLocalAudioStreamWithDummyVideoBy = async ()=>{
    const localStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
    }).catch(console.error);
    const canvas = document.createElement('canvas');
    canvas.getContext('2d');
    localStream.addTrack(canvas.captureStream().getVideoTracks()[0]);
    setLocalStream(localStream);
    return localStream;
};
const setLocalScreenShareStreamBy = async (useAudio)=>{
    const localStream = getLocalStream();
    const localScreenStream = await navigator.mediaDevices.getDisplayMedia({
        audio: useAudio,
        video: {
            width: {
                ideal: 1280
            },
            height: {
                ideal: 720
            },
            frameRate: {
                ideal: 30
            }
        }
    }).catch(console.error);
    if (!localScreenStream || localStream === undefined) {
        return false;
    }
    localStream.removeTrack(localStream.getVideoTracks()[0]);
    localStream.addTrack(localScreenStream.getVideoTracks()[0]);
    if (useAudio) {
        localStream.addTrack(localScreenStream.getAudioTracks()[0]);
    }
    setLocalStream(localStream);
    return localStream;
};
/**
 * @remarks
 * Peerの初期化
 * @remarks
 * Peerの初期化を分離
 * @param configKey
 * @returns Peer|undefined
 */ worldViewerWindow.initializePeer = async (configKey)=>{
    if (!navigator.mediaDevices) {
        debugLog('navigator.mediaDevices not found');
        return undefined;
    }
    // LocalStreamの取得
    const localStream = g_useVideoStreamFlag ? await setLocalAudioStreamWithDummyVideoBy() : await setLocalAudioStreamBy();
    // default mic mute
    worldViewerWindow.hel_skyway_set_mic_state(false);
    // Render local stream
    await helcore_skyway_PlayLocalStream(localStream);
    //
    const peer = new Peer({
        key: configKey === undefined ? getSkywayKey() : configKey,
        debug: 0
    });
    setPeer(peer);
    peer.on('error', console.error);
    return getPeer();
};
/**
 */ const helcore_skyway_GetLocalVideoElement = ()=>{
    return document.getElementById('js-local-stream');
};
/**
 */ const helcore_skyway_PlayLocalStream = async (localStream)=>{
    const localVideo = helcore_skyway_GetLocalVideoElement();
    localVideo.muted = true;
    localVideo.srcObject = localStream;
    localVideo.playsInline = true;
    await localVideo.play().catch(console.error);
};
/**
 */ const helcore_skyway_ResetLocalStream = ()=>{
    const localVideo = helcore_skyway_GetLocalVideoElement();
    localVideo.srcObject = null;
    localVideo.load();
};
/**
 * @remarks
 * 公開関数
 * hel_skyway_mainをラップしているのみ。front.js側への公開関数はhel_netの名称で統一するため
 * @param configKey
 * @virtual
 */ worldViewerWindow.hel_net_connect = async (configKey)=>{
    console.log("connect : " + getSkywayRoomID());
    worldViewerWindow.hel_skyway_main(configKey);
};
/**
 * @remarks
 * 公開関数
 * hel_skyway_mainと同様に接続を実行する機能だが、先にRoomIDを動的に取得する
 * @param configKey
 * @virtual
 */ worldViewerWindow.hel_net_connect_random_room = async (configKey)=>{
    // 空いているルームIDを取得
    worldViewerWindow.getRandomRoom(getWorldId(), {
        done: (response)=>{
            const room_id = response.data.room_id;
            debugLog(`[ getRandomRoom ] room_id = ${room_id}`);
            setSkyRoomId(room_id);
            worldViewerWindow.hel_skyway_main(configKey);
        },
        error: (error)=>debugLog(`[ getRandomRoom ] error = ${error}`)
    });
};
/**
 * 公開関数
 * ネットワークから切断する
 */ worldViewerWindow.hel_net_disconnect = ()=>{
    closeSkywayRoom();
    destroyPeer();
    closeLocalStream();
    helcore_skyway_ResetLocalStream();
};
/**
 * 公開関数
 * ネットワークの初期化
 */ worldViewerWindow.hel_net_initialize = async ()=>{
    await helcore_skyway_initialize();
};
/**
 * 公開関数
 * ルームへの接続
 */ worldViewerWindow.hel_net_connect_room = (roomid)=>{
    // Peer接続完了後にルームにジョインする
    const peer = getPeer();
    if (peer === undefined) {
        throw new Error('peer has not been set yet');
    }
    peer.on('open', ()=>{
        worldViewerWindow.helcore_skyway_join_by_roomid(roomid);
    });
};
/**
 * 公開関数
 * ルームからの切断
 */ worldViewerWindow.hel_net_disconnect_room = ()=>{
    closeSkywayRoom();
};
/**
 * 公開関数
 * トークルームへの接続
 */ worldViewerWindow.hel_net_connect_talk = (talkid)=>{
// Skyway実装ではルームとトークルームは同一のため、ここでは何もしない
};
/**
 * 公開関数
 * トークルームからの切断
 */ worldViewerWindow.hel_net_disconnect_talk = ()=>{
// Skyway実装ではルームとトークルームは同一のため、ここでは何もしない
};
/**
 * 公開関数
 * RoomURLの設定
 * コンフィグ画面に表示されるものです
 */ worldViewerWindow.hel_net_set_room_url = (url)=>{
    worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_SetRoomURL, url);
};
/**
 * ネットワークの初期化
 */ const helcore_skyway_initialize = async ()=>{
    await worldViewerWindow.initializePeer();
};
/**
 * @remarks
 * g_MultiPlay(XRWorldIngame, JRWorld_web）経由で
 * multiPlayの場合に参照
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 *
 * heliodor_front.jsから参照されるためglobal関数
 * @param configKey
 * @virtual
 */ worldViewerWindow.hel_skyway_main = async (configKey)=>{
    await helcore_skyway_initialize();
    // Peer接続完了後にルームにジョインする
    const peer = getPeer();
    if (peer === undefined) {
        throw new Error('peer has not been set yet');
    }
    peer.on('open', ()=>{
        worldViewerWindow.hel_skyway_join();
    });
};
/**
 * @remarks
 * JRWorld_webから呼出あり。
 * heliodor_front.jsから呼び出されるためglobal関数化
 * @param method
 * @param url
 * @param option
 */ worldViewerWindow.apiAjax = (method, url, option)=>{
    const api_url = SKYWAY_API_HOST + url;
    // 明示的にnullを送るケースあり
    const payload = option.data === undefined ? null : option.data;
    const ajax = new XMLHttpRequest();
    ajax.open(method, api_url);
    ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    ajax.send(JSON.stringify(payload));
    ajax.addEventListener('load', function(e) {
        try {
            if (e.target === null || e.target === undefined || !('response' in e.target)) {
                return;
            }
            const response = JSON.parse(e.target['response']);
            if (e.target['status'] === 200) {
                if (option.done !== undefined) {
                    option.done(response);
                }
            } else {
                if (option.error !== undefined) {
                    option.error(response);
                }
            }
        } catch (error) {
            debugLog(error);
        }
    }, false);
};
/**
 * @remarks
 * heliodor_room.jsから移植
 * TODO アプリケーション層より
 * @param world_id
 * @param option
 */ worldViewerWindow.getRandomRoom = (world_id, option)=>{
    if (!world_id) {
        return;
    }
    worldViewerWindow.apiAjax('GET', '/rooms/random/' + world_id, {
        done: option === undefined ? undefined : option.done,
        error: option === undefined ? undefined : option.error
    });
};
/**
 * @remarks
 * heliodor_room.jsから移植
 * TODO アプリケーション層より
 * @param world_id
 * @param option
 */ worldViewerWindow.createNewRoom = (world_id, option)=>{
    if (!world_id) {
        return;
    }
    worldViewerWindow.apiAjax('POST', '/rooms', {
        data: {
            world_id: world_id
        },
        done: option === undefined ? undefined : option.done,
        error: option === undefined ? undefined : option.error
    });
};
/**
 * @remarks
 * heliodor_room.jsから移植
 * TODO アプリケーション層より
 * @param room_id
 * @param player_count
 * @param option
 */ worldViewerWindow.sendHeartbeat = (room_id, player_count, option)=>{
    if (!room_id || !player_count) {
        return;
    }
    worldViewerWindow.apiAjax('POST', '/rooms/' + room_id + '/heartbeat', {
        data: {
            player_count: player_count
        },
        done: option === undefined ? undefined : option.done,
        error: option === undefined ? undefined : option.error
    });
};
// Replace ":" to "&colon\;"
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param text
 */ worldViewerWindow.hel_skyway_to_code_colon = (text)=>text.replace(':', '&colon;')
;
// Recovery "&colon;" to ":"
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param text
 */ worldViewerWindow.hel_skyway_to_char_colon = (text)=>text.replace('&colon;', ':')
;
worldViewerWindow.hel_skyway_main_with_display_media = async ()=>{
    const localVideo = document.getElementById('js-local-stream');
    // const remoteVideos = document.getElementById('js-remote-streams') as HTMLVideoElement;
    //
    // const sdkSrc = document.querySelector('script[src*=skyway]');
    if (!navigator.mediaDevices) {
        debugLog('navigator.mediaDevices not found');
        return;
    }
    const localAudioStream = await setLocalAudioStreamBy();
    const localVideoStream = await navigator.mediaDevices.getDisplayMedia({
        audio: false,
        video: {
            width: {
                ideal: 1280
            },
            height: {
                ideal: 720
            },
            frameRate: {
                ideal: 30
            }
        }
    }).catch(console.error);
    localAudioStream.addTrack(localVideoStream.getVideoTracks()[0]);
    // default mic mute
    worldViewerWindow.hel_skyway_set_mic_state(false);
    // Render local stream
    localVideo.muted = true;
    localVideo.srcObject = localAudioStream;
    localVideo.playsInline = true;
    await localVideo.play().catch(console.error);
    // eslint-disable-next-line require-atomic-updates
    worldViewerWindow.g_peer = new Peer({
        key: worldViewerWindow.g_SKYWAY_KEY,
        debug: 0
    });
    worldViewerWindow.g_peer.on('error', console.error);
    worldViewerWindow.g_peer.on('open', ()=>{
        worldViewerWindow.hel_skyway_join();
    });
};
/**
 * @remarks
 * 画面共有用のstreamを指定のユーザーに通知する
 */ const helcore_skyway_screenshare_to_player = (peerID)=>{
    const peer = getPeer();
    if (!peer) return;
    if (!g_ScreenShare_LocalStream) return;
    console.log('Call ' + peerID);
    peer.call(peerID, g_ScreenShare_LocalStream);
};
/**
 * @remarks
 * 画面共有の開始2
 */ worldViewerWindow.hel_skyway_start_screen_sharing_via_room = async (videoItemName, videoMaterialName, useCamera, useAudio)=>{
    if (!navigator.mediaDevices) {
        debugLog('navigator.mediaDevices not found');
        return;
    }
    let localVideoStream;
    if (useCamera) {
        localVideoStream = await navigator.mediaDevices.getUserMedia({
            audio: useAudio,
            video: true
        }).catch(console.error);
    } else {
        localVideoStream = await setLocalScreenShareStreamBy(useAudio);
    }
    if (!localVideoStream) {
        return false;
    }
    replaceLocalStream(localVideoStream);
    // Render local stream
    // 動画の再生
    worldViewerWindow.hel_video_stop();
    helcore_video_play(videoItemName, videoMaterialName, './Video/blankVideo.mp4', true, false, false);
    const video = getVideo();
    if (video !== undefined) {
        const previewVideoStream = new MediaStream();
        previewVideoStream.addTrack(localVideoStream.getVideoTracks()[0]);
        video.srcObject = previewVideoStream;
        await video.play();
    }
    setTimeout(()=>{
        // 全ユーザーに画面共有の開始を通知する
        worldViewerWindow.hel_skyway_send_data(`screenshare:start:${videoItemName}:${videoMaterialName}`);
    }, 1000);
    // グローバルに hel_onScreenShareStart が定義されていた場合に実行する
    if (typeof worldViewerWindow.hel_onScreenShareStart === 'function') {
        worldViewerWindow.hel_onScreenShareStart();
    }
    return true;
};
worldViewerWindow.hel_skyway_stop_screen_sharing_via_room = async ()=>{
    worldViewerWindow.hel_video_stop();
    const localStream = getLocalStream();
    if (localStream === undefined) {
        return false;
    }
    localStream.removeTrack(localStream.getVideoTracks()[0]);
    const canvas = document.createElement('canvas');
    canvas.getContext('2d');
    const dummyTrack = canvas.captureStream().getVideoTracks()[0];
    localStream.addTrack(dummyTrack);
    setLocalStream(localStream);
    replaceLocalStream(localStream);
    worldViewerWindow.hel_skyway_send_data(`screenshare:stop`);
    return true;
};
worldViewerWindow.hel_skyway_play_remote_video_stream = (remoteVideoStream, videoItemName, videoMaterialName)=>{
    // 動画の開始 ※本来ならMediaStreamを直接再生したい
    worldViewerWindow.hel_video_stop();
    helcore_video_play(videoItemName, videoMaterialName, './Video/blankVideo.mp4', true, false, false);
    setTimeout(()=>{
        if (worldViewerWindow.g_Video !== null) {
            worldViewerWindow.g_Video.srcObject = remoteVideoStream;
            worldViewerWindow.g_Video.play();
        }
    }, 500);
};
worldViewerWindow.hel_video_is_playing_same_stream = (stream)=>{
    const video = getVideo();
    const videoId = (video === null || video === void 0 ? void 0 : video.paused) === false && video.srcObject && video.srcObject.id;
    return videoId === stream.id;
};
// 映像ストリームを返す
// allがtrueの場合、全てを返す
// all falseの場合、ダミーではない再生可能なストリームだけ返す
worldViewerWindow.hel_skyway_get_remote_video_streams = (all = false)=>{
    if (all) {
        return videoStreams;
    }
    const playableStream = new Map();
    videoStreams.forEach((stream, peerId)=>{
        const videoTrack = stream.getVideoTracks()[0];
        if (videoTrack && videoTrack.getSettings().width) {
            playableStream.set(peerId, stream);
        }
    });
    return playableStream;
};
worldViewerWindow.hel_skyway_display_room_video = ()=>{
    worldViewerWindow.hel_skyway_send_data('screenshare:waitstart');
    if (worldViewerWindow.g_room !== null) {
        worldViewerWindow.g_room.on('stream', (stream)=>{
            const video = getVideo();
            if (video !== undefined) {
                if (video.srcObject !== stream) {
                    const videoTracks = stream.getVideoTracks();
                    if (videoTracks.length > 0) {
                        video.srcObject = stream;
                        video.playsInline = true;
                    }
                }
            }
        });
    }
};
/**
 * @remarks
 * heliodor_xrw_mainから参照あり
 * @param configKey?
 * @returns {Peer|undefined}
 *
 */ worldViewerWindow.hel_skyway_generate_peer = async (configKey)=>worldViewerWindow.initializePeer(configKey)
;
/**
 * @remarks
 * heliodor_skyway_wrwから参照あり
 * @param toggle
 *
 */ worldViewerWindow.hel_skyway_set_user_skyway_audio_gain = (toggle)=>setUseSkywayAudioGainToggle(toggle)
;
/*
*/ worldViewerWindow.hel_skyway_set_user_name = (name)=>{
    var currentname = getSkywayName();
    if (currentname === name) return;
    worldViewerWindow.hel_set_cookie('playername', name);
    worldViewerWindow.hel_post_TextField_UserName(true);
};
// 即時実行
const cookie_Skyway_MyName = worldViewerWindow.hel_get_cookie('playername');
if (cookie_Skyway_MyName !== undefined) {
    setSkywayName(cookie_Skyway_MyName);
}
worldViewerWindow.hel_skyway_set_show_chatbox(false);
worldViewerWindow.hel_skyway_set_avatar_from_cookie();
